<p-toast position="top-center" key="tc" />

@if (loading) {
  <div class="me-3 mt-3">
    <div class="d-flex align-items-center">
      <strong>Caricamento...</strong>
      <p-progress-spinner class="ms-auto" aria-label="Caricamento" [style]="{ width: '5rem', height: '5rem' }" />
    </div>
  </div>
} @else {
  <p-table [value]="items"
    [paginator]="true"
    [rows]="25"
    [globalFilterFields]="['sessionId', 'name', 'organization', 'team']"
    [exportHeader]="'customExportHeader'"
    stripedRows
    #dt>
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">Elenco Sessioni</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca..." />
          </div>
          <p-button icon="fas fa-plus" rounded raised (click)="onShowDialog(newItem)"
            pTooltip="Aggiungi sessione" tooltipPosition="bottom" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Organizzazione</th>
          <th>Squadra</th>
          <th>Sessione</th>
          <th>Data</th>
          <th style="width:10%"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-session>
        <tr [pSelectableRow]="session">
          <td>{{ session.sessionId }}</td>
          <td>{{ session.organization }}</td>
          <td>{{ session.team }}</td>
          <td>{{ session.name }}</td>
          <td>{{ session.date | date:'mediumDate' }}</td>
          <td>
            <p-button icon="fas fa-angle-right" (click)="onNavigate(session)" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  }


  <p-dialog header="Header"
    [(visible)]="showDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [contentStyle]="{'overflow': 'visible'}">

    <ng-template pTemplate="header">
      <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
        <label for="sessionId" class="text-left font-semibold">ID</label>
        <input pInputText id="sessionId" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="selectedItem.sessionId" />

        <label for="name" class="text-left font-semibold">Sessione</label>
        <input pInputText id="name" class="orgdept-input col-span-2" [disabled]="!isNew" [(ngModel)]="selectedItem.name" />
      </div>
    </ng-template>

    <p-tabs [(value)]="tabId">
      <p-tablist>
        <p-tab [value]="0">Generale</p-tab>
        <p-tab [value]="1">Descrizione</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="grid grid-cols-3 items-center gap-3">
            <div class="col-span-3 grid w-full grid-cols-3 items-center gap-3 px-4">
              <label for="organization" class="text-left font-semibold">Organizzazione</label>
              <p-select id="organization" [options]="organizationOptions" optionLabel="value" [(ngModel)]="selectedOrganization" class="col-span-2 text-left" appendTo="body" [disabled]="!isNew" (onChange)="onOrganizationSelected($event)" />
            </div>

            <div class="col-span-3 grid w-full grid-cols-3 items-center gap-3 px-4">
              <label for="team" class="text-left font-semibold">Squadra</label>
              <p-select id="team" [options]="teamOptions" optionLabel="value" [(ngModel)]="selectedTeam" class="col-span-2 text-left" appendTo="body" [disabled]="!isNew" (onChange)="onTeamSelected($event)" />
            </div>

            <hr class="col-span-3 col-start-1" />

            <div class="col-span-3 grid w-full grid-cols-3 items-center gap-3 px-4">
              <label for="date" class="text-left font-semibold">Data</label>
              <p-datepicker id="date" [(ngModel)]="selectedItem.date" class="col-span-2" [showButtonBar]="true" />
            </div>

          </div>
        </p-tabpanel>

        <p-tabpanel [value]="1">
          <div class="grid grid-cols-3 items-center gap-3">
            <label for="description" class="col-start-1 self-start text-left font-semibold">Descrizione</label>
            <textarea id="description" class="col-span-2 self-start" rows="5" cols="30" pTextarea [(ngModel)]="selectedItem.description"></textarea>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <ng-template pTemplate="footer">
      <p-button label="Chiudi"
        severity="secondary"
        variant="outlined"
        (click)="onCloseDialog()" />
        <p-button label="Salva"
          (click)="onSave()"
          [disabled]="selectedOrganization.id == 0 || selectedTeam.id == 0" />
        </ng-template>

      </p-dialog>
